import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Cushion, Grid, Image } from '@pitchero/react-ui';
import ClubLink from '../club-link';
import RosTopBanner from '../adverts/ros-top-banner';
import RosBottomBanner from '../adverts/ros-bottom-banner';

const NUMBER_OF_IMAGES_BEFORE_ADVERT = 20;

const PhotoGrid = ({ albumId, images, fixtureId, teamId, withAds }) => {
  const renderImage = (image) => {
    const aspect = image.width / image.height;

    let span = 2;
    let preset = 'photoSquare';

    /**
     * Aspect ratio values:
     * 9:16 0.5625
     * 2:3 0.66666666666667
     * 3:4 0.75
     * 4:5 0.8
     * 7:6 1.1666666666667
     * 5:4 1.25
     * 4:3 1.3333333333333
     * 3:2 1.5
     * 16:9 1.7777777777778
     */

    if (aspect > 0 && aspect <= 5 / 4) {
      span = 2;
      preset = 'photoPortrait';
    } else if (aspect >= 5 / 4) {
      span = 3;
      preset = 'photoLandscape';
    }

    const route = fixtureId ? 'team.match_centre.photos.image' : 'media.image';
    const routeParams = fixtureId
      ? { albumId, fixtureId, imageId: image.id, teamId }
      : { id: albumId, imageId: image.id };

    return (
      <div
        style={{
          gridColumn: `span ${span}`,
          overflow: 'hidden',
        }}
      >
        <ClubLink route={route} params={routeParams} key={image.id} replace>
          <a>
            <Image
              src={image.url}
              alt={image.title}
              shimmerOnLoad
              preset={preset}
              objectFit="cover"
              fullWidth
            />
          </a>
        </ClubLink>
      </div>
    );
  };

  const imagesBeforeAd = images.slice(0, NUMBER_OF_IMAGES_BEFORE_ADVERT);
  const imagesAfterAd = images.slice(NUMBER_OF_IMAGES_BEFORE_ADVERT);

  return (
    <>
      {images && (
        <>
          {withAds && (
            <Cushion bottom="medium">
              <RosTopBanner />
            </Cushion>
          )}
          <Grid
            preset="gallery"
            style={{
              gridAutoFlow: 'row-dense',
            }}
          >
            {map(imagesBeforeAd, (image) => (
              <React.Fragment key={image.id}>{renderImage(image)}</React.Fragment>
            ))}
          </Grid>
          {withAds && (
            <Cushion vertical="large">
              <RosBottomBanner />
            </Cushion>
          )}
          {imagesAfterAd.length > 0 && (
            <Cushion
              vertical="xxsmall"
              responsive={[{ minWidth: 'desk', props: { vertical: 'xsmall' } }]}
            >
              <Grid
                preset="gallery"
                style={{
                  gridAutoFlow: 'row-dense',
                }}
              >
                {map(imagesAfterAd, (image) => (
                  <React.Fragment key={image.id}>{renderImage(image)}</React.Fragment>
                ))}
              </Grid>
            </Cushion>
          )}
        </>
      )}
    </>
  );
};

PhotoGrid.defaultProps = {
  fixtureId: null,
  images: null,
  teamId: null,
  withAds: true,
};

PhotoGrid.propTypes = {
  albumId: PropTypes.number.isRequired,
  fixtureId: PropTypes.string,
  withAds: PropTypes.bool,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  teamId: PropTypes.number,
};

export default PhotoGrid;
